import React, { useEffect } from 'react';

const COUNTER_ID = 104649855;
const METRIKA_INIT_OPTIONS = {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: "dataLayer",
    accurateTrackBounce: true,
    trackLinks: true
};

export default function YandexMetrika() {

    useEffect(() => {
        if (window.ym) {
            return;
        }

        (function(m,e,t,r,i,k,a){
            m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            // Проверка на наличие скрипта
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
        })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=' + COUNTER_ID, 'ym');

        window.ym(COUNTER_ID, 'init', METRIKA_INIT_OPTIONS);},
        []);

    return (
        <noscript>
            <div>
                <img
                    src={`https://mc.yandex.ru/watch/${COUNTER_ID}`}
                    style={{ position: 'absolute', left: '-9999px' }}
                    alt="Yandex Metrika NoScript"
                />
            </div>
        </noscript>
    );
}